var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4902 6.54915C10.8354 6.54915 11.1152 6.82898 11.1152 7.17415V10.0908H14.0319C14.3771 10.0908 14.6569 10.3707 14.6569 10.7158C14.6569 11.061 14.3771 11.3408 14.0319 11.3408H11.1152V14.2575C11.1152 14.6027 10.8354 14.8825 10.4902 14.8825C10.1451 14.8825 9.86523 14.6027 9.86523 14.2575V11.3408H6.94857C6.60339 11.3408 6.32357 11.061 6.32357 10.7158C6.32357 10.3707 6.60339 10.0908 6.94857 10.0908H9.86523V7.17415C9.86523 6.82898 10.1451 6.54915 10.4902 6.54915ZM2.99023 5.92415C2.99023 4.42838 4.20279 3.21582 5.69857 3.21582H15.2819C16.7776 3.21582 17.9902 4.42838 17.9902 5.92415V15.5075C17.9902 17.0032 16.7776 18.2158 15.2819 18.2158H5.69857C4.20279 18.2158 2.99023 17.0032 2.99023 15.5075V5.92415ZM5.69857 4.46582C4.89315 4.46582 4.24023 5.11874 4.24023 5.92415V15.5075C4.24023 16.3129 4.89315 16.9658 5.69857 16.9658H15.2819C16.0873 16.9658 16.7402 16.3129 16.7402 15.5075V5.92415C16.7402 5.11874 16.0873 4.46582 15.2819 4.46582H5.69857Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.33add477fbd6127e6a4a866052288809.svg";
export { ForwardRef as ReactComponent };